import axios from 'axios';
import { store } from '../store';

export const getCampaigns = () => {
  const state = store.getState();
  const { token } = state.auth;
  store.dispatch({ type: 'SET_CAMPAIGNS_LOADING', payload: true });
  axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/campaign/`,
    headers: { Authorization: `Token ${token}` },
  }).then(({ data }) => {
    store.dispatch({ type: 'LOAD_CAMPAIGNS', payload: data });
    store.dispatch({ type: 'SET_CAMPAIGNS_LOADING', payload: false });
  }).catch(() => {
    store.dispatch({ type: 'SET_CAMPAIGNS_LOADING', payload: false });
  });
};

export const deleteCampaign = async ({ id }) => {
  const { token } = store.getState().auth;
  const { dispatch } = store;

  try {
    dispatch({ type: 'CAMPAIGN_DELETING', status: true });
    dispatch({ type: 'CAMPAIGN_DELETE_ERROR', status: false });
    await axios({
      method: 'delete',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/campaign/${id}`,
      headers: { Authorization: `Token ${token}` },
    });
    dispatch({ type: 'CAMPAIGN_DELETE_SUCCESS' });
    getCampaigns();
  } catch (error) {
    dispatch({ type: 'CAMPAIGN_DELETE_ERROR', status: true });
  } finally {
    dispatch({ type: 'CAMPAIGN_DELETING', status: false });
  }
};

export const createCampaign = (data) => {
  const state = store.getState();
  const { token } = state.auth;
  store.dispatch({ type: 'SET_CAMPAIGNS_SAVING', payload: true });

  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/campaign/`,
      headers: { Authorization: `Token ${token}` },
      data,
    }).then(() => {
      getCampaigns();
      store.dispatch({ type: 'SET_CAMPAIGNS_SAVING', payload: false });
      resolve();
    }).catch((err) => {
      store.dispatch({ type: 'SET_CAMPAIGNS_SAVING', payload: false });
      reject(err);
    });
  });
};

export const updateCampaign = (id, data) => {
  const state = store.getState();
  const { token } = state.auth;
  store.dispatch({ type: 'SET_CAMPAIGNS_UPDATING', payload: true });

  return new Promise((resolve, reject) => {
    axios({
      method: 'put',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/campaign/${id}/`,
      headers: { Authorization: `Token ${token}` },
      data,
    }).then(() => {
      store.dispatch({ type: 'UPDATE_CAMPAIGN', payload: { id, data } });
      store.dispatch({ type: 'SET_CAMPAIGNS_UPDATING', payload: false });
      resolve();
    }).catch((err) => {
      store.dispatch({ type: 'SET_CAMPAIGNS_UPDATING', payload: false });
      reject(err);
    });
  });
};
